module.exports = __webpack_public_path__ + "img/pension-icon.71b9aa51.svg";